import { BookOpen } from "lucide-react";
import React from "react";

function VariableInstructions2() {
  return (
    <div className="w-full mt-4  max-w-3xl mx-auto bg-white border border-gray-200 rounded-2xl shadow-sm p-6 space-y-6">
      {/* Header */}
      <div className="flex items-center gap-3">
        <div className="bg-blue-100 text-blue-700 p-2 rounded-lg"><BookOpen className="w-5 h-5 text-blue-600" />
</div>
        <div>
          <h2 className="text-lg font-semibold text-gray-800">
            Available Predefined Variables
          </h2>
          <p className="text-sm text-gray-500">
            Use these variables inside Subject and Email Body.
          </p>
        </div>
      </div>

      {/* Usage Info */}
      <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 text-sm text-gray-600">
        Wrap variables using double curly braces like:
        <span className="font-mono bg-gray-200 px-2 py-1 rounded ml-2">
          {"{{variable_name}}"}
        </span>
        <p className="mt-2 text-xs text-gray-400">
          Variables are case-sensitive and must match exactly.
        </p>
      </div>

      {/* Variable List */}
      <div className="overflow-x-auto">
        <table className="w-full text-sm text-left border-collapse">
          <thead>
            <tr className="border-b border-gray-200 text-gray-600">
              <th className="py-2 font-medium">Variable</th>
              <th className="py-2 font-medium">Description</th>
            </tr>
          </thead>
          <tbody className="text-gray-700">
            <tr className="border-b border-gray-100">
              <td className="py-2 font-mono text-blue-600">{"{{name}}"}</td>
              <td>Name of the user</td>
            </tr>
            <tr className="border-b border-gray-100">
              <td className="py-2 font-mono text-blue-600">{"{{email}}"}</td>
              <td>Email address of the user</td>
            </tr>
            <tr className="border-b border-gray-100">
              <td className="py-2 font-mono text-blue-600">{"{{phone}}"}</td>
              <td>Phone number of the user</td>
            </tr>
            <tr className="border-b border-gray-100">
              <td className="py-2 font-mono text-blue-600">{"{{company}}"}</td>
              <td>Company name</td>
            </tr>
            <tr>
              <td className="py-2 font-mono text-blue-600">{"{{app_name}}"}</td>
              <td>Application name</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Example Section */}
      <div className="bg-green-50 border border-green-200 rounded-xl p-4">
        <h3 className="text-sm font-semibold text-green-700 mb-2">
          Example Usage
        </h3>
        <pre className="text-xs text-gray-700 whitespace-pre-wrap font-mono">
          {`Subject: Welcome {{name}} to {{app_name}}

Hello {{name}},
We’re excited to have you at {{company}}.`}
        </pre>
      </div>
    </div>
  );
}

export default VariableInstructions2;
